import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import {
  API,
  color,
  Field2 as Field,
  AdCategoryHelper,
  AdProviderHelper,
  ProgrammaticBuyerHelper,
} from 'vibeguide';
import Grid from '@mui/material/GridLegacy';

function AdInformation({
  className = '',
  style = {},
  title = '',
  user,
  flightData,
  advertiserName,
  disabled = false,
  onChange = () => {},
  onChangeDropdown = () => {},
  onChangeAdvertiser = () => {},
  onChangeStartDate = () => {},
  onChangeEndDate = () => {},
}) {
  // disable ad provider for direct order types
  const disableAdProvider = flightData.orderType === 'direct' || flightData.orderType === 'direct-ext';

  return (
    <div
      className={classNames('AdInformation', className)}
      style={{
        position: 'relative',
        marginBottom: 16,
        padding: 16,
        backgroundColor: color.white,
        border: `1px solid ${color.whiteSmoke}`,
        fontSize: 12,
        userSelect: 'none',
        ...style,
      }}
    >
      {title && (
        <div
          className={classNames('ProfileContentTitle', className)}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 16,
            ...style,
          }}
        >
          <div
            style={{
              flexGrow: 1,
              fontSize: 14,
              fontWeight: 'bold',
              color: color.primary,
            }}
          >
            {title}
          </div>
        </div>
      )}
      <Grid spacing={2} container>
        <Grid xs={6} item>
          <Field
            type="dropdown"
            label="Delivery System"
            name="deliverySystem"
            value={flightData.deliverySystem}
            dropdownProps={{
              type: 'delivery system',
              attr: 'value',
              canCreate: user.can('flight_delivery_system.create'),
              successMessage: 'FLIGHTDELIVERYSYSTEM.CREATED',
              create: API.Flight.DeliverySystem.create,
              fetch: API.Flight.DeliverySystem.list,
            }}
            disabled={disabled}
            onChange={onChangeDropdown}
            tabIndex={6}
            required
          />
        </Grid>

        <Grid xs={6} item>
          <Field
            type="select"
            label="Ad Provider"
            name="adProvider"
            value={flightData.adProvider}
            selectProps={{
              tooltip: disableAdProvider
                ? 'You cannot change the ad provider. This is a Direct proposal.'
                : '',
              tooltipPlacement: 'top',
            }}
            options={[
              {
                label: '',
                value: '',
              },
              ...AdProviderHelper.list.map((adProvider) => {
                return {
                  label: adProvider.name,
                  value: adProvider.value,
                };
              }),
            ]}
            disabled={disabled || disableAdProvider}
            onChange={onChange}
            tabIndex={7}
            required
          />
        </Grid>

        <Grid xs={6} item>
          <Field
            type="dropdown"
            label="Advertiser"
            name="advertiser"
            value={advertiserName}
            tabIndex={8}
            dropdownProps={{
              type: 'advertiser',
              attr: 'name',
              fetch: API.Advertiser.list,
              create: API.Advertiser.create,
              canCreate: user.can('advertiser.create'),
              successMessage: 'ADVERTISER.CREATED',
            }}
            disabled={disabled}
            onChange={onChangeAdvertiser}
            required
          />
        </Grid>

        <Grid xs={6} item>
          <Field
            type="dropdown"
            label="Ad Category"
            name="category"
            value={flightData.category && flightData.category !== 'Not Selected'
              ? flightData.category
              : ''}
            dropdownProps={{
              type: 'category',
              attr: 'value',
              collection: AdCategoryHelper.list(),
            }}
            disabled={disabled}
            onChange={onChangeDropdown}
            tabIndex={9}
          />
        </Grid>

        <Grid xs={6} item>
          <Field
            type="text"
            label="Agency"
            name="agency"
            placeholder="Agency"
            value={flightData.agency}
            disabled={disabled}
            tabIndex={10}
            onChange={onChange}
          />
        </Grid>

        <Grid xs={6} item>
          <Field
            type="select"
            label="Programmatic Buyer"
            name="programmaticBuyer"
            value={flightData.programmaticBuyer}
            disabled={disabled}
            options={ProgrammaticBuyerHelper.list({ includeEmpty: true })}
            tabIndex={11}
            onChange={onChange}
          />
        </Grid>
      </Grid>

      <Grid spacing={2} sx={{ pt: 2 }} container>
        <Grid xs={6} item>
          <Field
            type="datepicker"
            label="Start Date"
            placeholder="YYYY-MM-DD"
            value={flightData.startDate}
            style={{
              width: '100%',
            }}
            dateProps={{
              format: 'YYYY-MM-DD',
              tooltip: 'This is determined by the earliest segment start date',
            }}
            disabled
            onChange={onChangeStartDate}
            tabIndex={12}
            required
          />
        </Grid>
        <Grid xs={6} item>
          <Field
            type="datepicker"
            label="End Date"
            placeholder="YYYY-MM-DD"
            value={flightData.endDate}
            dateProps={{
              format: 'YYYY-MM-DD',
              tooltip: 'This is determined by the latest segment end date',
            }}
            disabled
            onChange={onChangeEndDate}
            tabIndex={13}
            required
          />
        </Grid>
      </Grid>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(AdInformation);
